<template>
	<div class="height-100dvh">
		<header class="mob-back-header">
			<img
				class="mr-3"
				src="../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
				@click="goBack()"
			/>
			Search
		</header>
		<div class="mob-back-body">
			<SearchSuggestion />
		</div>
	</div>
</template>

<script>
import SearchSuggestion from "@/components/Home/SearchSuggestion.vue";
export default {
	components: {
		SearchSuggestion,
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
	},
};
</script>

<style lang="postcss" scoped></style>
